import * as React from "react"
import { motion, AnimatePresence } from "framer-motion"
import Header from "./header"
import Footer from "./footer"
import SocialIcons from "./social-icons"

const Layout = ({ page, children }) => {
  return (
    <>
      <AnimatePresence>
        <div
          className={
            "relative font-sans antialiased flex flex-col min-h-screen bg-gray-50"
          }
        >
          <Header page={page} />

          <SocialIcons />

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className={"flex flex-col grow"}
          >
            <main className={"grow"}>{children}</main>

            <Footer />
          </motion.div>
        </div>
      </AnimatePresence>
    </>
  )
}

export default Layout
